import { Component, OnInit, AfterViewInit } from '@angular/core';
import {FilterStorageService} from '../../services/filter-storage.service';
import {UsersService} from '../../api/users.service';
import {ActivatedRoute, Router} from '@angular/router';
import { ClickEventArgs } from '@syncfusion/ej2-navigations/toolbar';
import {UserChangePasswordComponent} from '../user-change-password/user-change-password.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserViewModel} from './user-view-model';
import {ProgressService} from '../../controls/progress.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit, AfterViewInit {
  list: UserViewModel[];
  commands: any;

  constructor(private filterStorage: FilterStorageService,
              private usersService: UsersService,
              private router: Router,
              private route: ActivatedRoute,
              private modalService: NgbModal,
              private progress: ProgressService) { }

  ngOnInit() {
    // indicator doesn't work first time
    this.reloadList();
    this.commands = [
      { text: 'Add', tooltipText: 'Add', prefixIcon: 'e-add', id: 'customadd' },
      { text: 'Import', tooltipText: 'upload file with users', prefixIcon: 'e-add', id: 'customimport' }
      ];
  }

  async reloadList() {
    this.list = [];
    const organization = this.filterStorage.getSelectedOrganization();
    if (organization != null) {
      const response = await this.usersService.getList(organization.id).toPromise();
      this.list = response.data.map(x => new UserViewModel(x));
    }
  }

  edit(data: UserViewModel) {
    const _ = this.router.navigate(['edit', data.id], {relativeTo: this.route});
  }

  add() {
    this.router.navigate(['add'], {relativeTo: this.route});
  }

  toolbar($event: ClickEventArgs) {
    console.log($event);

    if ($event.item.id === 'customadd') {
      this.add();
    }

    if ($event.item.id === 'customimport') {
      this.router.navigate(['import'], {relativeTo: this.route});
    }
  }

  async deactivateUser(data: UserViewModel) {
    this.progress.show();

    try {
      await this.usersService.deactivate(this.filterStorage.getSelectedOrganization().id, data.id).toPromise();
      // this.reloadList();
    } catch (e) {
      alert(e.error.message);
      console.error(e);
    } finally {
      this.progress.hide();
    }
  }

  async activateUser(data: UserViewModel) {
    this.progress.show();

    try {
      await this.usersService.activate(this.filterStorage.getSelectedOrganization().id, data.id).toPromise();
      // this.reloadList();
    } catch (e) {
      alert(e.error.message);
      console.error(e);
    } finally {
      this.progress.hide();
    }
  }

  changePassword(data: UserViewModel) {
    const modalRef = this.modalService.open(UserChangePasswordComponent);
    modalRef.componentInstance.user = data;
  }

  activeChanged(data: UserViewModel) {
    if (data.active) {
      this.activateUser(data);
    } else {
      this.deactivateUser(data);
    }
  }

  ngAfterViewInit(): void {
  }
}
